import Select from "tds/select";

export { Select };

customElements.define("tds-select", Select.CustomElementConstructor);
